<template>
  <v-btn
    v-bind="$attrs"
    :color="color"
    :variant="variant"
    :disabled="disabled || loading"
    @click="$emit('click', $event)"
  >
    <v-progress-circular
      v-if="loading"
      indeterminate
      size="25"
      width="3"
      class="test-spinner"
    />
    <slot v-else></slot>
  </v-btn>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'OareLoaderButton',
  inheritAttrs: false,
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      required: false,
    },
    variant: {
      type: String as PropType<
        'flat' | 'text' | 'elevated' | 'tonal' | 'outlined' | 'plain'
      >,
      default: 'elevated',
    },
  },
  emits: ['click'],
});
</script>
